module.exports = __webpack_public_path__ + "img/logo-2.9872f039.png";